import {
    REQUEST_EMPLOYEE_LIST,
    RECEIVE_EMPLOYEE_LIST,
    ERROR_EMPLOYEE_LIST,
    REQUEST_ALL_BUS_OPS_DIRECTORS,
    RECEIVE_ALL_BUS_OPS_DIRECTORS,
    ERROR_ALL_BUS_OPS_DIRECTORS,
    REQUEST_FIELD_DEVELOPMENT_MANAGERS,
    RECEIVE_FIELD_DEVELOPMENT_MANAGERS,
    ERROR_FIELD_DEVELOPMENT_MANAGERS,
    REQUEST_LENDER_LOGISTICS_MANAGERS,
    RECEIVE_LENDER_LOGISTICS_MANAGERS,
    ERROR_LENDER_LOGISTICS_MANAGERS,
    REQUEST_ALL_BUS_OPS_MANAGERS,
    RECEIVE_ALL_BUS_OPS_MANAGERS,
    ERROR_ALL_BUS_OPS_MANAGERS,
    REQUEST_OPERATIONS_MANAGERS, 
    RECEIVE_OPERATIONS_MANAGERS, 
    ERROR_OPERATIONS_MANAGERS, 
    REQUEST_SCHEDULING_USERS,
    RECEIVE_SCHEDULING_USERS,
    ERROR_SCHEDULING_USERS,
    REQUEST_CUSTOMER_EXPERIENCE_MANAGERS,
    RECEIVE_CUSTOMER_EXPERIENCE_MANAGERS,
    ERROR_CUSTOMER_EXPERIENCE_MANAGERS,
    REQUEST_CUSTOMER_EXPERIENCE_DIRECTORS,
    RECEIVE_CUSTOMER_EXPERIENCE_DIRECTORS,
    ERROR_CUSTOMER_EXPERIENCE_DIRECTORS,
} from 'typeConstants';

import { employee as initialState } from '../initialState.tsx';

const employee = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_EMPLOYEE_LIST:
            return {
                ...state,
                isFetchingEmployeeList: true
            };
        case RECEIVE_EMPLOYEE_LIST:
            return {
                ...state,
                employeeList: action.payload,
                isFetchingEmployeeList: false
            };
        case ERROR_EMPLOYEE_LIST:
            return {
                ...state,
                isFetchingEmployeeList: false
            };
        case REQUEST_ALL_BUS_OPS_DIRECTORS:
            return {
                ...state,
                fetchingBusOpsDirectors: true
            };
        case RECEIVE_ALL_BUS_OPS_DIRECTORS:
            return {
                ...state,
                busOpsDirectors: action.payload,
                fetchingBusOpsDirectors: false
            };
        case ERROR_ALL_BUS_OPS_DIRECTORS:
            return {
                ...state,
                fetchingBusOpsDirectors: false
            };
        case REQUEST_ALL_BUS_OPS_MANAGERS:
            return {
                ...state,
                fetchingBusOpsManagers: true,
            };
        case RECEIVE_ALL_BUS_OPS_MANAGERS:
            return {
                ...state,
                busOpsManagers: action.payload,
                fetchingBusOpsManagers: false,
            };
        case ERROR_ALL_BUS_OPS_MANAGERS:
            return {
                ...state,
                fetchingBusOpsManagers: false,
            };
        case REQUEST_FIELD_DEVELOPMENT_MANAGERS:
            return {
                ...state,
                fetchingFieldDevelopmentManagers: true
            };
        case RECEIVE_FIELD_DEVELOPMENT_MANAGERS:
            return {
                ...state,
                fieldDevelopmentManagers: action.payload,
                fetchingFieldDevelopmentManagers: false
            };
        case ERROR_FIELD_DEVELOPMENT_MANAGERS:
            return {
                ...state,
                fetchingFieldDevelopmentManagers: false
            };
        case REQUEST_LENDER_LOGISTICS_MANAGERS:
            return {
                ...state,
                isFetchingLenderLogisticsManagers: true,
            };
        case RECEIVE_LENDER_LOGISTICS_MANAGERS:
            return {
                ...state,
                isFetchingLenderLogisticsManagers: false,
                lenderLogisticsManagers: action.payload,
            };
        case ERROR_LENDER_LOGISTICS_MANAGERS:
            return {
                ...state,
                isFetchingLenderLogisticsManagers: false,
            };
        case REQUEST_OPERATIONS_MANAGERS:
            return {
                ...state,
                isFetchingFieldOperationsManagers: true,
            };
        case RECEIVE_OPERATIONS_MANAGERS:
            return {
                ...state,
                isFetchingFieldOperationsManagers: false,
                fieldOperationsManagers: action.payload,
            };
        case ERROR_OPERATIONS_MANAGERS:
            return {
                ...state,
                isFetchingFieldOperationsManagers: false,
            };
        case REQUEST_SCHEDULING_USERS:
            return {
                ...state,
                fetchingSchedulingUsers: true,
            };
        case RECEIVE_SCHEDULING_USERS:
            return {
                ...state,
                fetchingSchedulingUsers: false,
                schedulingUsers: action.payload,
            };
        case ERROR_SCHEDULING_USERS:
            return {
                ...state,
                fetchingSchedulingUsers: false,
            };
        case REQUEST_CUSTOMER_EXPERIENCE_MANAGERS:
            return {
                ...state,
                isFetchingCustomerExperienceManagers: true,
            };
        case RECEIVE_CUSTOMER_EXPERIENCE_MANAGERS:
            return {
                ...state,
                isFetchingCustomerExperienceManagers: false,
                customerExperienceManagers: action.payload,
            };
        case ERROR_CUSTOMER_EXPERIENCE_MANAGERS:
            return {
                ...state,
                isFetchingCustomerExperienceManagers: false,
            };
        case REQUEST_CUSTOMER_EXPERIENCE_DIRECTORS:
            return {
                ...state,
                isFetchingCustomerExperienceDirectors: true,
            };
        case RECEIVE_CUSTOMER_EXPERIENCE_DIRECTORS:
            return {
                ...state,
                isFetchingCustomerExperienceDirectors: false,
                customerExperienceDirectors: action.payload,
            };
        case ERROR_CUSTOMER_EXPERIENCE_DIRECTORS:
            return {
                ...state,
                isFetchingCustomerExperienceDirectors: false,
            };
        default:
            return state;
    }
};

export default employee;